import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSingleDateSelectionModel } from '@angular/material/datepicker';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/service/auth.service';

@Component({
  selector: 'app-resend-link',
  templateUrl: './resend-link.component.html',
  styleUrls: ['./resend-link.component.css']
})
export class ResendLinkComponent implements OnInit {

  loading = false
  public resendForm: FormGroup;
  emailErr: string

  //translations
  err1: string
  err2: string
  err3: string
  err4: string
  err5: string
  msg1: string

  constructor(public translate: TranslateService,
    private builder: FormBuilder,
    private authService: AuthService,
    private _snackBar: MatSnackBar) {
    this.getTranslatedStrings()
  }

  getTranslatedStrings() {
    this.translate.get(['REG_ERR2', 'REG_ERR3', 'FP_P3', 'REG_P4', 'LOG_ON_ERR5', 'REG_ERR6'])
      .subscribe(translations => {
        this.err1 = translations['REG_ERR2']
        this.err2 = translations['REG_ERR3']
        this.err3 = translations['FP_P3']
        this.err4 = translations['LOG_ON_ERR5']
        this.err5 = translations['REG_ERR6']
        this.msg1 = translations['REG_P4']
      })
  }

  ngOnInit(): void {

    this.resendForm = this.builder.group({
      email: new FormControl(null, [
        Validators.required,
        Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]),
    })
  }


  resendLink() {
    if (this.resendForm.controls.email.value === null) {
      this.emailErr = this.err1
    }
    else if (this.resendForm.controls.email.status === "INVALID") {
      this.emailErr = this.err2
    }
    else {
      //NO ERRORS
      const data: any = {
        email: this.resendForm.controls.email.value,
      }
      this.loading = true
      this.authService.getConfirmationEmail(data)
        .then(resp => {
          this.loading = false
          if (resp.status == 200) {
            console.log(resp.body)
            this._snackBar.open(this.msg1, "", {
              duration: 5000,
            });
          }
        })
        .catch(e => {
          this.loading = false

          if(e.status === 409){
            //USER ALREDY CONFIRMED!
            this._snackBar.open(this.err5, "", {
              duration: 5000,
            });
          }
          else if (e.status === 409){
            //NO USER WITH THAT EMAIL
            this._snackBar.open(this.err4, "", {
              duration: 5000,
            });
          }
          else {
            //GENERIC ERROR
            this._snackBar.open(this.err3, "", {
              duration: 5000,
            });
          }
        })
    }
  }

  clearEmailErr() {
    this.emailErr = ''
  }

  focusOutCheck() {
    if (this.resendForm.controls.email.value === null) {
      this.emailErr = this.err1
    }
    else if (this.resendForm.controls.email.status === "INVALID") {
      this.emailErr = this.err2
    }
  }

}
